import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useMemo } from "react";
import { Button, Form, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { TbGridDots } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import { components } from 'react-select';

import { ClientReportService } from "../../../services/ClientReportService";
import { BsCloudDownloadFill } from "react-icons/bs";
import { downloadXl } from "../../../functions";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectIsSuperUser, selectPermissions } from "../../../slice/user/userSlice";
import { Tooltip } from "@mui/material";
import DetailCutomRowStyle from "../../components/DetailCutomRowStyle";

function ClientReportDetails(params) {
  const { report_station, report_job_status, report_date_range, report_hour_count, clients, facilities, user, isTimeCount, facility_id } = params

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [selectValue, setSelectValue] = useState('');
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState([])
  const [day, setDay] = useState(true)
  const [year, setYear] = useState(false)
  const [week, setWeek] = useState(false)
  const [month, setMonth] = useState(false)
  const [monthList, setMonthList] = useState([])
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    search: "",
    client: "",
    created_date: "",
    date_range: "",
  })
  const permissions = useSelector(selectPermissions);
  const isSuperUser = useSelector(selectIsSuperUser);
  const isHavePermission = (name) => {
    return permissions?.includes(name) || isSuperUser
  }
  const clientReportService = new ClientReportService();
  const { getClientReportDetails, downloadClientReportDetails } = clientReportService


  const handleDetailFilterChange = (name) => {
    if (name === 'year') {
      setYear(true)
      setWeek(false)
      setMonth(false)
      setDay(false)
      fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, 'false', 'true', 'false', 'false');

    }
    else if (name === 'day') {
      setYear(false)
      setWeek(false)
      setMonth(false)
      setDay(true)
      fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, 'true', 'false', 'false', 'false');

    }
    else if (name === 'month') {
      setYear(false)
      setWeek(false)
      setMonth(true)
      setDay(false)
      fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, 'false', 'false', 'false', 'true');

    }
    else if (name === 'week') {
      setYear(false)
      setWeek(true)
      setMonth(false)
      setDay(false)
      fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, 'false', 'false', 'true', 'false');

    }

  }
  const handlePerRowsChange = async (newPerPage, page) => {
    setLimit(newPerPage);
    setPageNo(1)

    fetchData(1, newPerPage, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month);
    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month);
  };

  const fetchData = (page, limit, station, job_status, date_range, hour_count, user, day, year, week, month) => {

    setLoading(true)
    getClientReportDetails(page, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, clients, facilities, facility_id).then((response) => {
      setData(response?.data?.results);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
    });

  }


  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0,

      },
      {
        id: 'FILTER DATA',
        name: year ? 'YEAR' : week ? "WEEK" : month ? "MONTH" : "DATE",
        selector: row => row?.filter_data,
        cell: (row) =>

          <div>
            {row?.filter_data &&

              <div className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '170px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "120px" }} onClick={() => handleRowClick(row)}>
                  <Tooltip disableInteractive title={row?.filter_data} placement="top" arrow>
                    <span className="text-truncate"> {row?.filter_data}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '100px'
      },
      {
        id: 'PAYMENT835',
        name: 'PAYMENT835',
        selector: row => row?.no_of_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_of_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '80px'

      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_835}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'PAYMENT LITE',
        name: 'PAYMENT LITE',
        selector: row => row?.no_835_lite,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_835_lite}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '80px'


      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_835_lite,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_835_lite}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'CORRES',
        name: 'CORRES',
        selector: row => row?.correspondence,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.correspondence}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px'

      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_correspondence,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_correspondence}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'PAT PAY',
        name: 'PAT PAY',
        selector: row => row?.patient_pay,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px'

      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_patient_pay,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_patient_pay}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'PAT PAY 835',
        name: 'PAT PAY 835',
        selector: row => row?.patient_pay_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '75px'
      },

      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_patient_pay_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_patient_pay_835}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'CORRES 835',
        name: 'CORRES 835',
        selector: row => row?.correspondence_835,
        cell: (row) => <span onClick={() => handleRowClick(row)} > {row?.correspondence_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '70px'

      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_correspondence_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_correspondence_835}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'JOB TOTAL',
        name: 'JOB TOTAL',
        selector: row => row?.total,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '65px'


      },
      {
        id: 'REJECTED',
        name: 'REJECTED',
        selector: row => row?.rejected,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.rejected}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '70px'



      },
      {
        id: 'HOLD',
        name: 'HOLD',
        selector: row => row?.hold,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.hold}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '60px'



      },
      {
        id: 'MANUAL SPLIT',
        name: 'MANUAL SPLIT',
        selector: row => row?.file_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '85px'

      },
      {
        id: 'TIME',
        name: 'TIME',
        selector: row => row?.time_file_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.time_file_split}</span>,

        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '60px',
        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'TOTAL TIME',
        name: 'TOTAL TIME',
        selector: row => row?.work_time_total_time,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.work_time_total_time}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '80px',

        omit: report_hour_count == "" ? false : true,


      },
      {
        id: 'QUALITY',
        name: 'QUALITY %',
        selector: row => row?.quality,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.quality}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '65px'

      },
      {
        id: '# CLAIMS',
        name: '# CLAIMS',
        selector: row => row?.claims,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '65px'

      },
      {
        id: '# SVC LINES',
        name: '# SVC LINES',
        selector: row => row?.servicelines,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.servicelines}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '70px'


      },
      {
        id: 'LARGE BATCHES',
        name: 'LARGE BATCHES',
        selector: row => row?.large_batches,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.large_batches}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px',
        omit: isTimeCount

      },
      {
        id: 'COMPLETE',
        name: 'COMPLETE',
        selector: row => row?.complete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.complete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '70px'


      },
      {
        id: 'INCOMPLETE',
        name: 'INCOMPLETE',
        selector: row => row?.incomplete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.incomplete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '80px'


      },

      {
        id: 'JOB TOTAL',
        name: 'JOB TOTAL',
        selector: row => row?.total,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: !isTimeCount,
        minWidth: '70px'



      },
      {
        id: 'CPH',
        name: 'CPH',
        selector: row => row?.cph,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.cph}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        omit: isTimeCount,
        minWidth: '60px',


      },

    ],

    [limit, pageno, report_hour_count, week, year, month],
  );
  const countColumns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0,

      },
      {
        id: 'FILTER DATA',
        name: year ? 'YEAR' : week ? "WEEK" : month ? "MONTH" : "DATE",
        selector: row => row?.filter_data,
        cell: (row) =>

          <div>
            {row?.filter_data &&

              <div className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '90px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "90px" }} onClick={() => handleRowClick(row)}>
                  <Tooltip disableInteractive title={row?.filter_data} placement="top" arrow>
                    <span className="text-truncate"> {row?.filter_data}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '90px'
      },
      {
        id: 'PAYMENT835',
        name: 'PAYMENT835',
        selector: row => row?.no_of_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_of_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },

      {
        id: 'PAYMENT LITE',
        name: 'PAYMENT LITE',
        selector: row => row?.no_835_lite,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_835_lite}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },

      {
        id: 'CORRES',
        name: 'CORRES',
        selector: row => row?.correspondence,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.correspondence}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },

      {
        id: 'PAT PAY',
        name: 'PAT PAY',
        selector: row => row?.patient_pay,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },

      {
        id: 'PAT PAY 835',
        name: 'PAT PAY 835',
        selector: row => row?.patient_pay_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'
      },


      {
        id: 'CORRES 835',
        name: 'CORRES 835',
        selector: row => row?.correspondence_835,
        cell: (row) => <span onClick={() => handleRowClick(row)} > {row?.correspondence_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },

      {
        id: 'JOB TOTAL',
        name: 'JOB TOTAL',
        selector: row => row?.total,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },
      {
        id: 'REJECTED',
        name: 'REJECTED',
        selector: row => row?.rejected,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.rejected}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'



      },
      {
        id: 'HOLD',
        name: 'HOLD',
        selector: row => row?.hold,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.hold}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'



      },
      {
        id: 'MANUAL SPLIT',
        name: 'MANUAL SPLIT',
        selector: row => row?.file_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },

      {
        id: 'QUALITY',
        name: 'QUALITY %',
        selector: row => row?.quality,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.quality}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },
      {
        id: '# CLAIMS',
        name: '# CLAIMS',
        selector: row => row?.claims,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'

      },
      {
        id: '# SVC LINES',
        name: '# SVC LINES',
        selector: row => row?.servicelines,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.servicelines}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },
      {
        id: 'LARGE BATCHES',
        name: 'LARGE BATCHES',
        selector: row => row?.large_batches,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.large_batches}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px',

      },
      {
        id: 'COMPLETE',
        name: 'COMPLETE',
        selector: row => row?.complete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.complete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },
      {
        id: 'INCOMPLETE',
        name: 'INCOMPLETE',
        selector: row => row?.incomplete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.incomplete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px'


      },


      {
        id: 'CPH',
        name: 'CPH',
        selector: row => row?.cph,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.cph}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '90px',


      },

    ],

    [limit, pageno, report_hour_count, week, year, month],
  );
  const timeColumns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0,

      },
      {
        id: 'FILTER DATA',
        name: year ? 'YEAR' : week ? "WEEK" : month ? "MONTH" : "DATE",
        selector: row => row?.filter_data,
        cell: (row) =>

          <div>
            {row?.filter_data &&

              <div className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '80px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "80px" }} onClick={() => handleRowClick(row)}>
                  <Tooltip disableInteractive title={row?.filter_data} placement="top" arrow>
                    <span className="text-truncate"> {row?.filter_data}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '80px'
      },
      {
        id: 'PAYMENT835',
        name: 'PAYMENT835',
        selector: row => row?.no_of_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_of_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        minWidth: '100px'

      },

      {
        id: 'PAYMENT LITE',
        name: 'PAYMENT LITE',
        selector: row => row?.no_835_lite,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.no_835_lite}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'


      },

      {
        id: 'CORRES',
        name: 'CORRES',
        selector: row => row?.correspondence,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.correspondence}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'

      },

      {
        id: 'PAT PAY',
        name: 'PAT PAY',
        selector: row => row?.patient_pay,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'

      },

      {
        id: 'PAT PAY 835',
        name: 'PAT PAY 835',
        selector: row => row?.patient_pay_835,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.patient_pay_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'
      },


      {
        id: 'CORRES 835',
        name: 'CORRES 835',
        selector: row => row?.correspondence_835,
        cell: (row) => <span onClick={() => handleRowClick(row)} > {row?.correspondence_835}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'

      },

      {
        id: 'MANUAL SPLIT',
        name: 'MANUAL SPLIT',
        selector: row => row?.file_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'

      },


      {
        id: 'QUALITY',
        name: 'QUALITY %',
        selector: row => row?.quality,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.quality}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'

      },



      {
        id: 'JOB TOTAL',
        name: 'JOB TOTAL',
        selector: row => row?.total,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        // minWidth: '170px'



      },


    ],

    [limit, pageno, report_hour_count, week, year, month],
  );
  const conditionalRowStyles = [

    {
      when: row => colorRow.filter_data == row.filter_data ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.filter_data == row.filter_data ? '#e4e6ef' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];
  const handleRowClick = (row) => {
    setColorRow(row);

  };


  const searchFormik = useFormik({
    initialValues: {
      search: "",
      job_status: report_job_status,
      station: report_station,
      date_range: report_date_range,
      hour_count: report_hour_count

    },
    onSubmit: (values) => {
      console.log(values);
      searchData(values)

      setSearchedData({
        search: values?.search ? values?.search : "",
        job_status: values?.job_status ? values?.job_status : "",
        station: values?.station ? values?.station : "",
        date_range: values?.date_range ? values?.date_range : "",
        hour_count: values?.hour_count ? values?.hour_count : "",
      })
      handleResetDataTable()
    }
  })

  const [datetime, setDateTime] = useState([]);

  const searchData = ({ station, job_status, date_range, hour_count }) => {
    fetchData(1, limit, station, selectValue, datetime, hour_count)
  }

  const showTooltip = (text, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );


  const handleResetDataTable = () => {
    setRerenderDataTable(true)
    // setTimeout(() => {
    //   setRerenderDataTable(false)
    // }, 200);
  }

  const [loader, setLoader] = useState(false);
  const handleDownload = () => {
    setLoader(true)
    downloadClientReportDetails(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, clients, facilities, facility_id).then((response) => {
      setLoader(false)
      downloadXl(response?.data?.export_file)
    });
  }
  useEffect(() => {
    fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month);
  }, [])

  return (
    <React.Fragment>
      <section className="section">
        <div className="row align-items-top py-2 gap-2 gap-md-5">
          <div className="col-lg-12">
            <div className="card card_background">

              <Form onSubmit={searchFormik.handleSubmit} >
                <div className="d-flex justify-content-end" style={{ height: "20px" }}>
                  <div className="px-3 pt-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

                    <div>
                      <Tooltip disableInteractive title={"Year"} placement="top" arrow>
                        <div class="form-check">
                          <input class="form-check-input me-1" type="radio" onChange={() => handleDetailFilterChange('year')} checked={year} name="year" id="year1" />
                          <label class="form-check-label" for="year1" style={{ fontSize: "14px", fontWeight: "600" }}>
                            Year
                          </label>
                        </div>
                      </Tooltip>

                    </div>
                    <div>
                      <Tooltip disableInteractive title={"Month"} placement="top" arrow>
                        <div class="form-check">
                          <input class="form-check-input me-1" type="radio" onChange={() => handleDetailFilterChange('month')} checked={month} name="month" id="month2" />
                          <label class="form-check-label" for="month2" style={{ fontSize: "14px", fontWeight: "600" }}>
                            Month
                          </label>
                        </div>
                      </Tooltip>

                    </div>


                    <div>
                      <Tooltip disableInteractive title={"Week"} placement="top" arrow>

                        <div class="form-check">
                          <input class="form-check-input me-1" onChange={() => handleDetailFilterChange('week')} checked={week} type="radio" name="week" id="week3" />
                          <label class="form-check-label" for="week3" style={{ fontSize: "14px", fontWeight: "600" }}>
                            Week
                          </label>
                        </div>
                      </Tooltip>

                    </div>
                    <div>
                      <Tooltip disableInteractive title={"Day"} placement="top" arrow>

                        <div class="form-check">
                          <input class="form-check-input me-1" onChange={() => handleDetailFilterChange('day')} checked={day} type="radio" name="flexRadioDefault" id="flexRadioDefault4" />
                          <label class="form-check-label" for="flexRadioDefault4" style={{ fontSize: "14px", fontWeight: "600" }}>
                            Day
                          </label>
                        </div>
                      </Tooltip>

                    </div>
                  </div>
                  {isHavePermission("detail_export_client_report_management") &&

                    <div className="px-3 pt-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

                      <div>
                        <Tooltip disableInteractive title={"Download"} placement="top" arrow>
                          {!loader ?

                            <span style={{ cursor: "pointer" }} className="svg-icon svg-icon-3" onClick={() => { handleDownload() }}>
                              <BsCloudDownloadFill color="#1ba1a7" />
                            </span>
                            :
                            <span className="svg-icon svg-icon-3">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </span>
                          }

                        </Tooltip>
                      </div>
                    </div>
                  }
                </div>

              </Form>


              <div className="card-body p-common">
                <div className="table-responsive">
                  <div className="dashboardtable custom_background">
                    {/* {!reRenderDataTable && */}
                    <DataTable
                      // className="custom-datatable-details"
                      paginationDefaultPage={pageno}

                      fixedHeader={true}
                      progressPending={loading}
                      data={data}
                      columns={report_hour_count === "false" ? timeColumns : report_hour_count === "true" ? countColumns : columns}
                      pointerOnHover={true}
                      pagination
                      paginationServer
                      // highlightOnHover
                      paginationTotalRows={totalRows}
                      paginationPerPage={limit}
                      paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      conditionalRowStyles={conditionalRowStyles}
                      theme="detail_solarized"
                      customStyles={DetailCutomRowStyle}
                      onRowClicked={handleRowClick}
                    />
                    {/* } */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment >
  )
}
export default ClientReportDetails




